import { handleResponse } from "@/utils/errorResponseHandlers";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ENDPOINTS } from "@/api/application-api";
import { useParams } from "react-router-dom";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast } from "@/utils/toast";

export const useCreateCustomModel = (authToken: string) => {
  const { workspaceId } = useParams();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (modelInfo: any) => {
      const response = await fetch(ENDPOINTS.models(String(workspaceId)), {
        method: "POST",
        headers: jsonAuthHeaders(authToken),
        body: JSON.stringify(modelInfo),
      });
      return handleResponse(response);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["models", workspaceId],
      });
    },
    onError: (error: any) => {
      displayErrorToast(error.message);
    },
  });
};
